import React, { PureComponent } from 'react';
import { func, string, shape } from 'prop-types';
import cn from 'classnames';
import { t } from 'i18next';
import { IonIcon } from '@ionic/react';
import { locateOutline } from 'ionicons/icons';

import styles from './styles.module.scss';
import { KIND_ICONS } from './constants';

class Result extends PureComponent {
  handleClick = () => {
    const { onClick, data } = this.props;

    onClick(data || {});
  };

  render() {
    const { data } = this.props;
    const { description, kind } = data || {};

    return (
      <button
        type="button"
        className={`row middle m-bottom-2 full-width ${styles.result}`}
        onClick={this.handleClick}>
        <span
          className={cn('text-base', styles.description, {
            'text-menu-link text-caribbean-green': !description
          })}>
          <IonIcon
            className={`m-right-2 ${styles.icon}`}
            icon={description ? KIND_ICONS[kind] || KIND_ICONS.other : locateOutline}
          />
          {description || t('StoreSearchBar:currentLocation')}
        </span>
      </button>
    );
  }
}

Result.propTypes = {
  onClick: func.isRequired,
  data: shape({
    description: string,
    placeId: string
  })
};

export default Result;
